// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { OpenApiWithRelationsSchema } from './OpenApiRelationsSchema'
import type { OpenApiWithRelations } from './OpenApiRelationsSchema'
import { ApplicationFileSchema } from './ApplicationFileSchema';

/////////////////////////////////////////
// APPLICATION FILE RELATION SCHEMA
/////////////////////////////////////////

export type ApplicationFileRelations = {
  application?: ApplicationWithRelations | null;
  openApis: OpenApiWithRelations[];
};

export type ApplicationFileWithRelations = z.infer<typeof ApplicationFileSchema> & ApplicationFileRelations

export const ApplicationFileWithRelationsSchema: z.ZodType<ApplicationFileWithRelations> = ApplicationFileSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema).nullable(),
  openApis: z.lazy(() => OpenApiWithRelationsSchema).array(),
}))